"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'parent',
  data: function data() {
    return {
      refreshRouterViewKey: null,
      keepAliveNameList: [],
      keepAliveNameNewList: []
    };
  },
  computed: {
    // 设置主界面切换动画
    setTransitionName: function setTransitionName() {
      return this.$store.state.themeConfig.themeConfig.animation;
    },
    isTagHistory: function isTagHistory() {
      return this.$store.state.themeConfig.themeConfig.isTagsview;
    }
  },
  created: function created() {
    var _this = this;
    /**
     * 获取需要保持活动状态的组件名称列表
     */
    this.keepAliveNameList = this.getKeepAliveNames();
    // 监听标签页视图刷新路由视图事件
    this.bus.$on('onTagsViewRefreshRouterView', function (path) {
      // 如果当前路由路径不等于传入的路径，则直接返回false
      if (_this.$route.path !== path) return false;
      // 过滤掉当前路由对应的组件名称，并重新设置keepAliveNameList
      _this.keepAliveNameList = _this.getKeepAliveNames().filter(function (name) {
        return _this.$route.name !== name;
      });
      // 刷新路由视图key
      _this.refreshRouterViewKey = _this.$route.path;
      // 在下一个tick中重新设置keepAliveNameList
      _this.$nextTick(function () {
        _this.refreshRouterViewKey = null;
        /**
         * 获取需要保持活动状态的组件名称列表
         */
        _this.keepAliveNameList = _this.getKeepAliveNames();
      });
    });
  },
  methods: {
    // 获取路由缓存列表（name），默认路由全部缓存
    getKeepAliveNames: function getKeepAliveNames() {
      return this.$store.state.keepAliveNames.keepAliveNames;
      // return this.$store.state.menu.keepAliveNames;
    }
  }
};